
import { getGoldRecordList } from '../../common/js/api.js'
import Scroller from 'vux/src/components/scroller/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
Scroller,
XHeader,
XInput,
XTextarea,
XButton,
Box,
Group,
CellBox,
Cell
},
data() {
return {
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
},
pullupConfig: {
content: '上拉加载更多',
downContent: '松开进行加载',
upContent: '上拉加载更多',
loadingContent: '加载中...'
},
pulldownConfig: {
content: '下拉刷新',
downContent: '下拉刷新',
upContent: '释放刷新',
loadingContent: '加载中...'
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: '',
extInfo: { status: undefined },
payType: 0
},
disabled:
typeof navigator !== 'undefined' &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
}
},
methods: {
refresh() {
let self = this
self.pageInfo.pageIndex = 1
self.getGoldRecordList()
},
loadMore() {
let self = this
self.pageInfo.pageIndex++
self.getGoldRecordList()
},

getGoldRecordList() {
let self = this
getGoldRecordList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content)
} else {
self.list = data.Content
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup()
} else {
self.$refs.scroller.disablePullup()
}
setTimeout(() => {
self.$refs.scroller.donePullup()
self.$refs.scroller.donePulldown()
}, 50)
})
}
},
mounted() {
this.getGoldRecordList()
}
}



// WEBPACK FOOTER //
// ./src/components/usercenter/PointRecord.vue